import { Recurrence } from '../types';

interface Params {
  recurrence?: Recurrence;
  byweekday?: number[];
}

export const setRecurrenceDays = ({ recurrence, byweekday }: Params) => {
  if (!recurrence) return;

  return {
    ...recurrence,
    byweekday,
  };
};
